import React from 'react';
import styles from './RateSummaryOverview.module.scss';

interface RateSummaryOverviewProps {
  summary: string;
  keyActions: string[];
}

export const RateSummaryOverview: React.FC<RateSummaryOverviewProps> = ({ summary, keyActions }) => {
  // In a real application, this data would come from an API call using the unitId
  return (
    <div className={styles.overview}>
      <div className={styles.content}>
        <div className={styles.summary}>
          <h3>Summary</h3>
          <p>
            {summary}
          </p>
        </div>

        <div className={styles.actions}>
          <h3>Key Action Items</h3>
          <ul className="slim">
            { keyActions.map((action, idx) => (
              <li key={idx}>{action}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}; 